export default __webpack_public_path__ + "static/background-86873885da03de14aca4080fc83901b2.mp4";